<template>
  <a-modal class="device" width="90%" :title="$t('customer.addDevice')" :bodyStyle="{ padding: 0 }" :visible="visible" @cancel="cancel">
    <a-table
      style="margin: 10px 15px 0"
      :loading="loading"
      :pagination="pagination"
      :data-source="data"
      :columns="deviceInnerColumns"
      :rowSelection="rowSelection"
      :rowKey="record => record.id"
      @change="handleTableChange"
    >
      <div
        slot="filterDropdown"
        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        style="padding: 8px"
      >
        <a-input
          v-ant-ref="c => (searchInput = c)"
          :placeholder="`搜索 ${column.title}`"
          :value="selectedKeys[0]"
          style="width: 188px; margin-bottom: 8px; display: block;"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
        />
        <a-button
          type="primary"
          icon="search"
          size="small"
          style="width: 90px; margin-right: 8px"
          @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
        >
          {{ $t('buttons.search') }}
        </a-button>
        <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
          {{ $t('buttons.reset') }}
        </a-button>
      </div>
      <a-icon
        slot="filterIcon"
        slot-scope="filtered"
        type="search"
        :style="{ color: filtered ? '#108ee9' : undefined }"
      />
      <template slot="customRender" slot-scope="text, record, index, column">
        <span v-if="searchText && searchedColumn === column.dataIndex">
          <template
            v-for="(fragment, i) in text
              .toString()
              .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
          >
            <mark
              v-if="fragment.toLowerCase() === searchText.toLowerCase()"
              :key="i"
              class="highlight"
              >{{ fragment }}</mark
            >
            <template v-else>{{ fragment }}</template>
          </template>
        </span>
        <template v-else>
          {{ text }}
        </template>
      </template>
    </a-table>
    <template v-slot:footer>
      <a-button type="primary" @click="close">{{ $t('customer.add') }}</a-button>
      <a-button @click="cancel">{{ $t('common.close') }}</a-button>
    </template>
  </a-modal>
</template>

<script>
import { searchDeviceList } from '@/api/device'
import moment from 'moment'

const queryParams = {
  query: [],
  filter: [
    {
      field: 'customerId',
      value: ''
    }
  ],
  sort: [
    {
      field: 'updatedAt',
      value: 'DESC'
    }
  ]
}

export default {
  props: {
    visible: Boolean,
    customerId: Number,
    deviceList: Array
  },
  created() {
    this.deviceMap = {}
  },
  data() {
    return {
      data: [],
      searchText: '',
      searchInput: null,
      searchedColumn: '',
      rowSelection: {
        selectedRowKeys: [],
        onChange: this.rowChange
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      deviceInnerColumns: [
        {
          title: () => (<div>{this.$t('common.deviceCode')}<span class="icons unset" style="cursor: pointer;" data-index="0"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input type="text"  allow-clear data-index="0" /></div>),
          dataIndex: 'code',
          key: 'code'
        },
        {
          title: () => (<div>{this.$t('common.deviceName')}<span class="icons unset" style="cursor: pointer;" data-index="1"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input type="text" class="username" allow-clear data-index="1" /></div>),
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: () => (<div>{this.$t('customer.company')}<span class="icons unset" style="cursor: pointer;" data-index="2"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input type="text" class="username" allow-clear data-index="2" /></div>),
          dataIndex: 'customer.company',
          key: 'customer.company'
        },
        {
          title: () => (<div>{this.$t('common.model')}<span class="icons unset" style="cursor: pointer;" data-index="3"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input type="text" class="username" allow-clear data-index="3" /></div>),
          dataIndex: 'model',
          key: 'model'
        },
        {
          title: () => (<div>{this.$t('common.driverType')}<span class="icons unset" style="cursor: pointer;" data-index="4"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input type="text" class="username" allow-clear data-index="4" /></div>),
          dataIndex: 'driverType',
          key: 'driverType'
        },
        {
          title: () => (<div>{this.$t('common.protocolCode')}<span class="icons unset" style="cursor: pointer;" data-index="5"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input type="text" class="username" allow-clear data-index="5" /></div>),
          dataIndex: 'protocolCode',
          key: 'protocolCode',
          scopedSlots: { customRender: 'protocolCode' }
        },
        {
          title: () => (<div>{this.$t('common.dtuCode')}<span class="icons unset" style="cursor: pointer;" data-index="6"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input type="text" class="username" allow-clear data-index="6" /></div>),
          dataIndex: 'dtuCode',
          key: 'dtuCode',
          scopedSlots: { customRender: 'dtuCode' }
        },
        {
          title: () => (<div>{this.$t('common.createdAt')}<span class="icons unset" style="cursor: pointer; right: -52px" data-index="7"><a-icon type="caret-up" /><a-icon type="caret-down" /></span></div>),
          dataIndex: 'createdAt',
          key: 'createdAt',
          width: '180px',
          scopedSlots: { customRender: 'createdAt' }
        },
        {
          title: () => (<div>{this.$t('common.updatedAt')}<span class="icons DESC" style="cursor: pointer; right: -52px" data-index="8"><a-icon type="caret-up" /><a-icon type="caret-down" /></span></div>),
          dataIndex: 'updatedAt',
          key: 'updatedAt',
          width: '180px',
          scopedSlots: { customRender: 'updatedAt' }
        }
      ],
    };
  },
  watch: {
    visible(value) {
      if (value) {
        queryParams.filter[0].value = this.customerId
        console.log(this.deviceList);
        this.rowSelection.selectedRowKeys = this.deviceList.map(i => {
          this.deviceMap[i.id] = i
          return i.id
        })
        this.data.length === 0 && this.searchDeviceList()
        this.$nextTick(() => {
        const ss = document.querySelectorAll('.device .ant-table-column-title > div span.icons')
        ss.forEach(i => {
          i.addEventListener('click', () => {
            let c = ''
            switch (i.classList[1]) {
              case 'ASC':
                c = 'DESC'
                break;
              case 'DESC':
                c = 'unset'
                break;
              case 'unset':
                c = 'ASC'
                break;
              default:
                break;
            }
            i.classList.remove(i.classList[1])
            i.classList.add(c)
            const ii = document.querySelectorAll('.device .ant-table-column-title > div span.icons:not(.unset)')
            const sort = Array.from(ii).map(item => {
              const index = +item.dataset['index']
              return {
                field: this.deviceInnerColumns[index].key,
                value: item.classList[1]
              }
            })
            queryParams.sort = sort
            this.searchDeviceList()
          })
        })
        const ips = document.querySelectorAll('.device .ant-input')
        ips.forEach(ip => {
          ip.addEventListener('keyup', ({ key, target }) => {
            // console.log(key, target.value.trim())
            if (key === 'Enter') {
              this.pagination.current = 1
              // target.value.trim() && this.handleSearch()
              this.handleSearchDevice()
            }
          })
        })
      })
        // searchDeviceList(1, 50, queryParams).then(async res => {
        //   if (res.data.total <= 50) {
        //     this.data = res.data.records
        //   } else {
        //     const { data } = await searchDeviceList(1, res.data.total)
        //     this.data = data.records
        //   }
        //   this.data.forEach(item => {
        //     item.createdAt = moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
        //     item.updatedAt = moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss')
        //   })
        // })
      }
    }
  },
  methods: {
    async searchDeviceList() {
      this.loading = true
      try {
        const { data } = await searchDeviceList(this.pagination.current, this.pagination.pageSize, queryParams)
        this.data = data.records.map(r => {
          r.createdAt = moment(r.createdAt).format('YYYY-MM-DD HH:mm:ss')
          r.updatedAt = moment(r.updatedAt).format('YYYY-MM-DD HH:mm:ss')
          return r
        })
        this.pagination.total = data.total
        // console.log(this.data[0]);
      } catch(e) {
        console.log(e);
      } finally {
        this.loading = false
      }
    },
    handleSearchDevice() {
      const ips = document.querySelectorAll('.device .ant-input')
      queryParams.query = []
      ips.forEach(ip => {
        if (ip.value.trim()) {
          queryParams.query.push({
            field: this.deviceInnerColumns[+ip.dataset['index']].key,
            value: +ip.dataset['index'] === 0 ? ip.value.split('-').join('') : ip.value
          })
        }
      })
      this.searchDeviceList()
    },
    cancel () {
      this.$emit('close', null)
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = '';
    },
    rowChange (selectedRowKeys, selectedRows) {
      selectedRows.forEach(s => {
        this.deviceMap[s.id] = s
      })
      this.rowSelection.selectedRowKeys = selectedRowKeys
    },
    close () {
      const list = []
      this.rowSelection.selectedRowKeys.forEach(i => {
        list.push(this.deviceMap[i])
      })
      this.$emit('close', list)
    },
    handleTableChange(p) {
      this.pagination = p
      this.searchDeviceList()
    }
  }
}
</script>

<style scoped>
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-table-column-title div {
  position: relative;
}
.ant-table-column-title span {
  position: relative;
}
.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}
.ant-table-column-title span.icons {
  position: absolute;
  right: 18px;
}
.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}
.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
</style>
